import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  keyword: "",
};

const searchSlice = createSlice({
  name: "searchBar",
  initialState,
  reducers: {
    setSearchBar: (state, action) => {
      state.keyword = action.payload;
    },
    clearSearchBar: (state) => {
      state.keyword = "";
    },
  },
});

export const { setSearchBar, clearSearchBar } = searchSlice.actions;
export default searchSlice.reducer;
